import { useEffect, useState } from 'react'

export function useRightContainer({
  isMobile,
  activeOtherSection,
  rightRailRef,
}) {
  const [rightContainerHeight, setRightContainerHeight] = useState(
    'calc(100vh - 240px)',
  )

  useEffect(() => {
    if (!isMobile && activeOtherSection) {
      const handleScroll = () => {
        if (rightRailRef.current) {
          const rect = rightRailRef.current.getBoundingClientRect()
          const distanceToTop = rect.top - window.scrollY // distance from top of page
          if (distanceToTop < 75) {
            setRightContainerHeight('calc(100vh - 191px)')
          } else {
            setRightContainerHeight('calc(100vh - 240px)')
          }
        }
      }

      window.addEventListener('scroll', handleScroll)
      handleScroll()

      return () => {
        window.removeEventListener('scroll', handleScroll)
      }
    }
  }, [isMobile, activeOtherSection])

  return {
    rightContainerHeight,
  }
}
